import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <p>{`I founded Druidic Inc in 2020 with the vision to provide quality, affordable tech services to my local community in the Louisville area.  With more than 10 years working in IT, I know how easily tech can become a time-wasting frustration. I specialize in making tech work for you. `}</p>
    <blockquote>
      <p parentName="blockquote">{`Joel Amunrud`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      